import React from "react";
import { FaEdit } from "react-icons/fa";
import { RxReset } from "react-icons/rx";

const CompareCoordiantes = ({
  coordinatesRef,
  setNewCoordinates,
  setIsEdit,
  imageDetails,
  classes,
  modelDetails,
  newCoordinates,
  handleNeckInputChange,
  handleEditClick,
  handleInputChange,
  isEdit,
}) => {
  return (
    <div>
      {" "}
      <div className="flex mx-4 my-2 justify-end">
        {coordinatesRef.current && (
          <button
            className="flex p-2 bg-gray-100 items-center justify-center text-blue-500 rounded-lg coBack"
            onClick={() => {
              setNewCoordinates(JSON.parse(imageDetails.sCoordinate));
              setIsEdit(false);
              coordinatesRef.current = false;
            }}
          >
            <RxReset />
          </button>
        )}
      </div>
      <div className={`w-full h-full d-lg-flex d-sm-flex ${classes.modalDiv}`}>
        <div className="">
          <div
            className="bg-gray-300 flex-shrink-0 "
            style={{
              width: "400px",
              height: "450px",
              position: "relative",
            }}
          >
            <div className="mainDemo"></div>
            <div className="mainDemo0"></div>
            <div className="mainDemo1"></div>
            <div className="mainDemo2"></div>
            <div className="mainDemo3"></div>
            <img
              src={imageDetails.sURL}
              alt={`Modal `}
              className="h-full w-full"
            />
          </div>
        </div>
        <div className={classes.editDiv}>
          <div className="space-y-4">
            <div>
              <span className="block text-md font-semibold">
                Old Co-ordinates
              </span>
              <div className="flex flex-col pb-2 m-1">
                {imageDetails?.sCoordinate && (
                  <>
                    {
                      <>
                        {(imageDetails.iBodyTypeId === "1" ||
                          imageDetails.iBodyTypeId === 1) && (
                          <div className="flex flex-col gap-4">
                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Left Coordinates(Orange)
                              </span>
                              <span style={{ color: "orange" }}>
                                {
                                  JSON.parse(imageDetails?.sCoordinate)?.wrist[
                                    "left"
                                  ][0]
                                }
                                ,{" "}
                                {
                                  JSON.parse(imageDetails?.sCoordinate)?.wrist[
                                    "left"
                                  ][1]
                                }
                              </span>
                            </div>

                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Right Coordinates(Green):
                              </span>
                              <span style={{ color: "green" }}>
                                {
                                  JSON.parse(imageDetails?.sCoordinate)?.wrist[
                                    "right"
                                  ][0]
                                }
                                ,{" "}
                                {
                                  JSON.parse(imageDetails?.sCoordinate)?.wrist[
                                    "right"
                                  ][1]
                                }
                              </span>
                            </div>

                            {/* <div className="flex flex-col">
                                    <span className="font-semibold text-gray-700">
                                      Center Coordinates:
                                    </span>
                                    <span style={{ color: "tomato" }}>
                                      {
                                        JSON.parse(imageDetails?.sCoordinate)[
                                          "center"
                                        ][0]
                                      }
                                      ,{" "}
                                      {
                                        JSON.parse(imageDetails?.sCoordinate)[
                                          "center"
                                        ][1]
                                      }
                                    </span>
                                  </div> */}
                          </div>
                        )}
                        {(imageDetails.iBodyTypeId === "3" ||
                          imageDetails.iBodyTypeId === 3) && (
                          <div className="flex flex-col gap-4  h-60 overflow-y-scroll">
                            {Object.keys(
                              imageDetails.sCoordinate
                                ? JSON.parse(imageDetails?.sCoordinate)
                                : ""
                            )?.map((key, index) => (
                              <>
                                {JSON.parse(imageDetails?.sCoordinate)[key]
                                  ?.left && (
                                  <div key={index} className="flex flex-col">
                                    <span className="font-semibold text-gray-700">
                                      {key} Finger Coordinates:
                                    </span>

                                    <div className="flex flex-col">
                                      <span className="font-semibold text-gray-700">
                                        Left Coordinates(Orange)
                                      </span>
                                      <span style={{ color: "orange" }}>
                                        {JSON.parse(imageDetails?.sCoordinate)[
                                          key
                                        ]?.left &&
                                          JSON.parse(imageDetails?.sCoordinate)[
                                            key
                                          ]?.left[0]}
                                        ,{" "}
                                        {JSON.parse(imageDetails?.sCoordinate)[
                                          key
                                        ]?.left &&
                                          JSON.parse(imageDetails?.sCoordinate)[
                                            key
                                          ]?.left[1]}
                                      </span>
                                    </div>

                                    <div className="flex flex-col">
                                      <span className="font-semibold text-gray-700">
                                        Right Coordinates(Green):
                                      </span>
                                      <span style={{ color: "green" }}>
                                        {JSON.parse(imageDetails?.sCoordinate)[
                                          key
                                        ]?.right &&
                                          JSON.parse(imageDetails?.sCoordinate)[
                                            key
                                          ]?.right[0]}
                                        ,{" "}
                                        {JSON.parse(imageDetails?.sCoordinate)[
                                          key
                                        ]?.right &&
                                          JSON.parse(imageDetails?.sCoordinate)[
                                            key
                                          ]?.right[1]}
                                      </span>
                                    </div>

                                    {/* <div className {console.log("called")
                          }="flex flex-col">
                                            <span className="font-semibold text-gray-700">
                                              Center Coordinates:
                                            </span>
                                            <span style={{ color: "tomato" }}>
                                              {JSON.parse(
                                                imageDetails?.sCoordinate
                                              )[key]?.center &&
                                                JSON.parse(
                                                  imageDetails?.sCoordinate
                                                )[key]?.center[0]}
                                              ,
                                              {JSON.parse(
                                                imageDetails?.sCoordinate
                                              )[key]?.center &&
                                                JSON.parse(
                                                  imageDetails?.sCoordinate
                                                )[key]?.center[1]}
                                            </span>
                                          </div> */}
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                        )}
                        {(imageDetails.iBodyTypeId === "4" ||
                          imageDetails.iBodyTypeId === 4) && (
                          <div className="flex flex-col gap-4">
                            {/* Left Coordinates */}
                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Left Coordinates (Neck Wide)(Orange):
                              </span>
                              <span style={{ color: "orange" }}>
                                {JSON.parse(imageDetails?.sCoordinate)
                                  ?.neck_coordinates?.neck_wide
                                  ? JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_coordinates?.neck_wide
                                      ?.left_point[0]
                                  : JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_mask_wide?.left_point[0]}
                                ,{" "}
                                {JSON.parse(imageDetails?.sCoordinate)
                                  ?.neck_coordinates?.neck_wide
                                  ? JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_coordinates?.neck_wide
                                      ?.left_point[1]
                                  : JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_mask_wide?.left_point[1]}
                              </span>
                            </div>

                            {/* Right Coordinates */}
                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Right Coordinates (Neck Wide)(Green):
                              </span>
                              <span style={{ color: "green" }}>
                                {JSON.parse(imageDetails?.sCoordinate)
                                  ?.neck_coordinates?.neck_wide
                                  ? JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_coordinates?.neck_wide
                                      ?.right_point[0]
                                  : JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_mask_wide?.right_point[0]}
                                ,{" "}
                                {JSON.parse(imageDetails?.sCoordinate)
                                  ?.neck_coordinates?.neck_wide
                                  ? JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_coordinates?.neck_wide
                                      ?.right_point[1]
                                  : JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_mask_wide?.right_point[1]}
                              </span>
                            </div>

                            {/* Rotation Angle */}
                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Rotation Angle (Neck Wide):
                              </span>
                              <span style={{ color: "tomato" }}>
                                {
                                  JSON.parse(imageDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ?.rotation_angle
                                }
                                °
                              </span>
                            </div>
                          </div>
                        )}
                        {(imageDetails.iBodyTypeId === "2" ||
                          imageDetails.iBodyTypeId === 2) && (
                          <div className="flex flex-col gap-4 ">
                            {/* Ear Coordinates */}

                            <div className="flex flex-col">
                              <span className="font-semibold text-gray-700">
                                Ear Coordinates:
                              </span>
                              <span className="text-black break-words">
                                {
                                  JSON.parse(imageDetails?.sCoordinate)
                                    ?.ear_coordinates[0][0]
                                }
                                ,{" "}
                                {
                                  JSON.parse(imageDetails?.sCoordinate)
                                    ?.ear_coordinates[0][1]
                                }{" "}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    }
                  </>
                )}
              </div>
            </div>

            <button
              className="flex p-2 bg-gray-100 items-center justify-center text-blue-500 rounded-lg w"
              onClick={handleEditClick}
            >
              <FaEdit size={15} />
              &nbsp; Edit Coordinates
            </button>
          </div>

          <div className="space-y-4">
            {!isEdit ? (
              <>
                {Object.keys(newCoordinates ? newCoordinates : "").length >
                0 ? (
                  <>
                    {coordinatesRef.current && (
                      <div>
                        <span className="block text-md font-semibold">
                          New Coordinates
                        </span>
                        <div className="flex flex-col pb-2 m-1">
                          {(modelDetails.iBodyTypeId === "1" ||
                            modelDetails.iBodyTypeId === 1) && (
                            <div className="flex flex-col gap-4">
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Left Coordinates(Orange)
                                </span>
                                <span style={{ color: "orange" }}>
                                  {newCoordinates?.left[0]},{" "}
                                  {newCoordinates?.left[1]}
                                </span>
                              </div>
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Right Coordinates(Green):
                                </span>
                                <span style={{ color: "green" }}>
                                  {newCoordinates?.right[0]},{" "}
                                  {newCoordinates?.right[1]}
                                </span>
                              </div>
                            </div>
                          )}
                          {(modelDetails.iBodyTypeId === "3" ||
                            modelDetails.iBodyTypeId === 3) && (
                            <div className="flex flex-col gap-4  h-60 overflow-y-scroll">
                              {Object.keys(newCoordinates).map((key, index) => (
                                <>
                                  {newCoordinates[key]?.left && (
                                    <div key={index} className="flex flex-col">
                                      <span className="font-semibold text-gray-700">
                                        {key} Finger Coordinates:
                                      </span>

                                      <div className="flex flex-col">
                                        <span className="font-semibold text-gray-700">
                                          Left Coordinates(Orange)
                                        </span>
                                        <span style={{ color: "orange" }}>
                                          {newCoordinates[key]?.left &&
                                            newCoordinates[key]?.left[0]}
                                          ,
                                          {newCoordinates[key]?.left &&
                                            newCoordinates[key]?.left[1]}
                                        </span>
                                      </div>

                                      <div className="flex flex-col">
                                        <span className="font-semibold text-gray-700">
                                          Right Coordinates(Green):
                                        </span>
                                        <span style={{ color: "green" }}>
                                          {newCoordinates[key]?.right &&
                                            newCoordinates[key]?.right[0]}
                                          ,
                                          {newCoordinates[key]?.right &&
                                            newCoordinates[key]?.right[1]}
                                        </span>
                                      </div>

                                      {/* <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700">
                                                  Center Coordinates:
                                                </span>
                                                <span style={{ color: "tomato" }}>
                                                  {newCoordinates[key]
                                                    ?.center &&
                                                    newCoordinates[key]
                                                      ?.center[0]}
                                                  ,
                                                  {newCoordinates[key]
                                                    ?.center &&
                                                    newCoordinates[key]
                                                      ?.center[1]}
                                                </span>
                                              </div> */}
                                    </div>
                                  )}
                                </>
                              ))}
                            </div>
                          )}
                          {(modelDetails.iBodyTypeId === "4" ||
                            modelDetails.iBodyTypeId === 4) && (
                            <div className="flex flex-col gap-4">
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Left Coordinates (Neck Wide)(Orange):
                                </span>
                                <span style={{ color: "orange" }}>
                                  {JSON.parse(modelDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ? JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_coordinates?.neck_wide
                                        ?.left_point[0]
                                    : JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_mask_wide?.neck_wide
                                        ?.left_point[0]}
                                  ,{" "}
                                  {JSON.parse(modelDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ? JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_coordinates?.neck_wide
                                        ?.left_point[1]
                                    : JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_mask_wide?.left_point[1]}
                                </span>
                              </div>

                              {/* Right Coordinates */}
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Right Coordinates (Neck Wide)(Green):
                                </span>
                                <span style={{ color: "green" }}>
                                  {JSON.parse(modelDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ? JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_coordinates?.neck_wide
                                        ?.right_point[0]
                                    : JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_mask_wide?.right_point[0]}
                                  ,{" "}
                                  {JSON.parse(modelDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ? JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_coordinates?.neck_wide
                                        ?.right_point[1]
                                    : JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_mask_wide?.right_point[1]}
                                </span>
                              </div>

                              {/* Rotation Angle */}
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Rotation Angle (Neck Wide):
                                </span>
                                <span style={{ color: "tomato" }}>
                                  {JSON.parse(modelDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide
                                    ? JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_coordinates?.neck_wide
                                        ?.rotation_angle
                                    : JSON.parse(modelDetails?.sCoordinate)
                                        ?.neck_mask_wide?.rotation_angle}
                                  °
                                </span>
                              </div>
                            </div>
                          )}{" "}
                          {(modelDetails.iBodyTypeId === "2" ||
                            modelDetails.iBodyTypeId === 2) && (
                            <div className="flex flex-col gap-4 ">
                              <div className="flex flex-col">
                                <span className="font-semibold text-gray-700">
                                  Ear Coordinates:
                                </span>
                                <span className="text-black break-words">
                                  {newCoordinates?.ear_coordinates[0][0]},
                                  {newCoordinates?.ear_coordinates[0][1]}{" "}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
              </>
            ) : (
              <div>
                <span className="block text-md font-semibold">
                  Edit Coordinates
                </span>
                <div className="flex flex-col gap-4">
                  {imageDetails?.iBodyTypeId === 1 && (
                    <div className="flex flex-col gap-4">
                      <div className="flex flex-col">
                        <label className="font-semibold text-gray-700">
                          Left Coordinates(Orange)
                        </label>
                        <div className="flex items-center  gap-2">
                          <label className="text-gray-700">X:</label>
                          <input
                            type="text"
                            className="border rounded p-2"
                            value={newCoordinates?.wrist?.left[0]}
                            onChange={(e) =>
                              handleInputChange(
                                "left",
                                0,
                                undefined,
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="flex items-center  gap-2">
                          <label className="text-gray-700">Y:</label>
                          <input
                            type="text"
                            className="border rounded p-2"
                            value={newCoordinates?.wrist?.left[1]}
                            onChange={(e) =>
                              handleInputChange(
                                "left",
                                1,
                                undefined,
                                e.target.value
                              )
                            }
                          />
                        </div>
                        imageDetails
                      </div>
                      <div className="flex flex-col">
                        <label className="font-semibold text-gray-700">
                          Right Coordinates(Green):
                        </label>
                        <div className="flex items-center  gap-2">
                          <label className="text-gray-700">X:</label>
                          <input
                            type="text"
                            className="border rounded p-2"
                            value={newCoordinates?.wrist?.right[0]}
                            onChange={(e) =>
                              handleInputChange(
                                "right",
                                0,
                                undefined,
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="flex items-center  gap-2">
                          <label className="text-gray-700">Y:</label>
                          <input
                            type="text"
                            className="border rounded p-2"
                            value={newCoordinates?.wrist?.right[1]}
                            onChange={(e) =>
                              handleInputChange(
                                "right",
                                1,
                                undefined,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      {/* <div className="flex flex-col">
                            <label className="font-semibold text-gray-700">
                              Center Coordinates:
                            </label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={newCoordinates?.center[0]}
                              onChange={(e) =>
                                handleInputChange(
                                  "center",
                                  0,
                                  undefined,
                                  e.target.value
                                )
                              }
                            />
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={newCoordinates?.center[1]}
                              onChange={(e) =>
                                handleInputChange(
                                  "center",
                                  1,
                                  undefined,
                                  e.target.value
                                )
                              }
                            />
                          </div> */}
                    </div>
                  )}
                  {(imageDetails?.iBodyTypeId === "3" ||
                    imageDetails?.iBodyTypeId === 3) && (
                    <div className="flex flex-col gap-4 h-60 overflow-y-scroll">
                      {Object.keys(newCoordinates).map((key, index) => (
                        <>
                          {newCoordinates[key]?.left && (
                            <div
                              key={index}
                              className="flex flex-col border-b pb-4"
                            >
                              <span className="font-semibold text-gray-700">
                                {key} Finger Coordinates:
                              </span>

                              {newCoordinates[key]?.left && (
                                <div className="flex flex-col gap-2 mt-2">
                                  <label className="font-semibold text-gray-700">
                                    Left Coordinates(Orange)
                                  </label>
                                  <div className="flex items-center  gap-2">
                                    <label className="text-gray-700">X:</label>
                                    <input
                                      type="text"
                                      className="border rounded p-2"
                                      value={newCoordinates[key]?.left[0] || ""}
                                      onChange={(e) =>
                                        handleInputChange(
                                          key,
                                          "left",
                                          0,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="flex items-center  gap-2">
                                    <label className="text-gray-700">Y:</label>
                                    <input
                                      type="text"
                                      className="border rounded p-2"
                                      value={newCoordinates[key]?.left[1] || ""}
                                      onChange={(e) =>
                                        handleInputChange(
                                          key,
                                          "left",
                                          1,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}

                              {newCoordinates[key]?.right && (
                                <div className="flex flex-col gap-2 mt-2">
                                  <label className="font-semibold text-gray-700">
                                    Right Coordinates(Green):
                                  </label>
                                  <div className="flex items-center  gap-2">
                                    <label className="text-gray-700">X:</label>
                                    <input
                                      type="text"
                                      className="border rounded p-2"
                                      value={
                                        newCoordinates[key]?.right[0] || ""
                                      }
                                      onChange={(e) =>
                                        handleInputChange(
                                          key,
                                          "right",
                                          0,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="flex items-center  gap-2">
                                    <label className="text-gray-700">Y:</label>
                                    <input
                                      type="text"
                                      className="border rounded p-2"
                                      value={
                                        newCoordinates[key]?.right[1] || ""
                                      }
                                      onChange={(e) =>
                                        handleInputChange(
                                          key,
                                          "right",
                                          1,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}

                              {/* {newCoordinates[key]?.center && (
                                    <div className="flex flex-col gap-2 mt-2">
                                      <label className="font-semibold text-gray-700">
                                        Center Coordinates:
                                      </label>
                                <input
                                  type="text"
                                  className="border rounded p-2"
                                        value={
                                          newCoordinates[key]?.center[0] || ""
                                        }
                                  onChange={(e) =>
                                    handleInputChange(
                                            key,
                                            "center",
                                            0,
                                            e.target.value
                                          )
                                        }
                                      />
                                      <input
                                        type="text"
                                        className="border rounded p-2"
                                        value={
                                          newCoordinates[key]?.center[1] || ""
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            key,
                                            "center",
                                      1,
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                                  )} */}
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                  {imageDetails.iBodyTypeId === "4" ||
                    (imageDetails.iBodyTypeId === 4 && (
                      <div className="flex flex-col gap-4">
                        <div className="flex flex-col">
                          <label className="font-semibold text-gray-700">
                            Left Coordinates (Neck Wide)(Orange):
                          </label>
                          <div className="flex items-center  gap-2">
                            <label className="text-gray-700">X:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={
                                newCoordinates?.neck_coordinates?.neck_wide
                                  ? newCoordinates?.neck_coordinates?.neck_wide
                                      ?.left_point[0]
                                  : newCoordinates?.neck_mask_wide
                                      ?.left_point[0]
                              }
                              onChange={(e) =>
                                handleNeckInputChange(
                                  "neck_coordinates",
                                  "neck_wide",
                                  "left_point",
                                  0,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="flex items-center  gap-2">
                            <label className="text-gray-700">Y:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={
                                newCoordinates?.neck_coordinates?.neck_wide
                                  ? newCoordinates?.neck_coordinates?.neck_wide
                                      ?.left_point[1]
                                  : newCoordinates?.neck_mask_wide
                                      ?.left_point[1]
                              }
                              onChange={(e) =>
                                handleNeckInputChange(
                                  "neck_coordinates",
                                  "neck_wide",
                                  "left_point",
                                  1,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="flex flex-col">
                          <label className="font-semibold text-gray-700">
                            Right Coordinates (Neck Wide)(Green):
                          </label>
                          <div className="flex items-center  gap-2">
                            <label className="text-gray-700">X:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={
                                newCoordinates?.neck_coordinates?.neck_wide
                                  ? newCoordinates?.neck_coordinates?.neck_wide
                                      ?.right_point[0]
                                  : newCoordinates?.neck_mask_wide
                                      ?.right_point[0]
                              }
                              onChange={(e) =>
                                handleNeckInputChange(
                                  "neck_coordinates",
                                  "neck_wide",
                                  "right_point",
                                  0,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="flex items-center  gap-2">
                            <label className="text-gray-700">Y:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={
                                JSON.parse(imageDetails?.sCoordinate)
                                  ?.neck_coordinates?.neck_wide
                                  ? JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_coordinates?.neck_wide
                                      ?.left_point[0]
                                  : JSON.parse(imageDetails?.sCoordinate)
                                      ?.neck_mask_wide?.right_point[1]
                              }
                              onChange={(e) =>
                                handleNeckInputChange(
                                  "neck_coordinates",
                                  "neck_wide",
                                  "right_point",
                                  1,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="flex flex-col">
                          <label className="font-semibold text-gray-700">
                            Rotation Angle (Neck Wide):
                          </label>
                          <input
                            type="number"
                            className="border rounded p-2"
                            value={
                              JSON.parse(imageDetails?.sCoordinate)
                                ?.neck_coordinates?.neck_wide
                                ? JSON.parse(imageDetails?.sCoordinate)
                                    ?.neck_coordinates?.neck_wide?.left_point[0]
                                : JSON.parse(imageDetails?.sCoordinate)
                                    ?.neck_mask_wide?.rotation_angle
                            }
                            onChange={(e) =>
                              handleNeckInputChange(
                                "neck_coordinates",
                                "neck_wide",
                                "rotation_angle",
                                undefined,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    ))}

                  {imageDetails.iBodyTypeId === "2" ||
                    (imageDetails.iBodyTypeId === 2 && (
                      <div className="flex flex-col gap-4">
                        {/* Ear Coordinates Input */}
                        <div className="flex flex-col">
                          <label className="font-semibold text-gray-700">
                            Ear Coordinates(Black):
                          </label>
                          <div className="flex items-center gap-2">
                            <label className="text-gray-700">X:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={newCoordinates?.ear_coordinates[0][0]}
                              onChange={(e) =>
                                handleInputChange(
                                  "ear_coordinates",
                                  0,
                                  0,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="flex items-center gap-2">
                            <label className="text-gray-700">Y:</label>
                            <input
                              type="text"
                              className="border rounded p-2"
                              value={newCoordinates?.ear_coordinates[0][1]}
                              onChange={(e) =>
                                handleInputChange(
                                  "ear_coordinates",
                                  0,
                                  1,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                {/* <button
                      className="flex p-2 bg-gray-100 items-center justify-center text-blue-500 rounded-lg"
                      onClick={handleSave}
                    >
                      Save Changes
                    </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareCoordiantes;
